import EyeIcon from '../icons/EyeIcon'

const ShopProductCard = ({ product, categories = [], onClick }) => {
  const actualProduct = product.product || product
  const imageUrl = actualProduct?.primaryImageUrl
  const name = actualProduct.name
  const categoryId = actualProduct?.categoryId

  const categoryName = categories.find((cat) => cat.id === categoryId)?.name || ''
  const views = product.totalProductViews ?? 0

  return (
    <div
      className="flex items-center border border-[#E7B77A] rounded-lg p-3 mb-2 lg:mb-0 bg-background cursor-pointer hover:shadow-md transition-shadow"
      onClick={onClick}
    >
      <img
        src={imageUrl}
        alt={name}
        className="w-16 h-16 object-contain rounded mr-3"
        onError={(e) => {
          e.target.onerror = null
          e.target.src = '/placeholder-image.png'
        }}
      />
      <div className="flex-1 flex flex-col justify-center">
        <div className="flex justify-between items-center">
          <div className="flex flex-col">
            <span className="block font-medium text-base">{name}</span>
          </div>
          <span className="font-bold text-lg text-red-500">{product?.priceText}</span>
        </div>
        <div className="flex justify-between items-center mb-2">
          <span className="text-gray-500 text-base font-fontFamily font-normal">
            {categoryName}
          </span>
          <span className="flex items-center text-[#B3005E] text-base">
            <EyeIcon />
            {views}
          </span>
        </div>
      </div>
    </div>
  )
}

export default ShopProductCard
